import React, {Component} from 'react';
import Select from 'react-select';
import PropTypes from "prop-types";
import Machines from "../utils/entities/Machines";
import StaticFunctions from "../utils/StaticFunctions";


class MachineMultiSelector extends Component {

    static propTypes = {
        machines: PropTypes.instanceOf(Machines).isRequired,
        onMachineSelected: PropTypes.func.isRequired,
    };

    static defaultProps = {
        classes: '',
        currentMachines: null,
        currentLocation: null,
        addAllOption: false,
    };

    constructor(props) {

        super(props);

        this.state = {
            currentMachines: null
        };

        this.translate = this.props.translate;

        this.selectMachine = this.selectMachine.bind(this);
        this.filterCurrentMachines = this.filterCurrentMachines.bind(this);

    }

    componentDidMount() {

        if (this.props.currentMachines) {
            this.setState({
                currentMachines: this.props.currentMachines
            });
        }

    }

    getOptions() {

        let machines = [];

        if (this.props.currentLocation !== null) {
            machines = this.props.machines ? this.props.machines.getMachinesByLocationId(this.props.currentLocation) : [];
        } else {
            machines = this.props.machines ? this.props.machines.getAllMachines('name', 'asc') : [];
        }

        const sortedMachines = StaticFunctions.getSortedData(machines, 'alias', 'string');
        const opt = [];

        if (this.props.addAllOption)  {
            opt.push({
                value: 'all',
                label: this.translate('all')
            })
        }

        for (let ix in sortedMachines) {
            let machine = sortedMachines[ix];

            opt.push({
                value: String(machine.machine_id),
                label: machine.getLabel ? machine.getLabel() : machine.alias ? machine.alias : machine.machine_id
            })
        }

        return opt;

    }

    selectMachine(machines) {

        let nextMachines = null;
        if (machines) {
            nextMachines = Array.isArray(machines) ? machines : [machines];
        }

        this.setState({
            currentMachines: nextMachines
        });

        if (this.props.onMachineSelected) this.props.onMachineSelected(nextMachines)

    }

    filterCurrentMachines() {

        if (!this.state.currentMachines || !this.props.machines) return [];

        const currentMachines = Array.isArray(this.state.currentMachines)
            ? this.state.currentMachines
            : [this.state.currentMachines];

        return currentMachines.filter(
            (selectedMachine) => {
                return this.props.machines.machines.find(
                    (machine) => {
                        return (machine.machine_id === selectedMachine.value);
                    }
                );
            }
        );

    }

    render() {

        const opts = this.getOptions();
        const classes = ['chosen-container', 'chosen-container-multi', this.props.classes].join(' ').trim();
        const selectedMachines = this.filterCurrentMachines();

        return (
            <Select
                name="form-field-name"
                className={classes}
                style={{width: '260px'}}
                options={opts}
                onChange={this.selectMachine}
                value={selectedMachines}
                placeholder={this.translate('select') + '...'}
                clearable={false}
                noResultsText={this.translate('noResultsFound')}
                isMulti={true}
            />
        )

    }

}

export default MachineMultiSelector;